var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426.3 207.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#221f20;}.cls-2{fill:#7fabea;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.7,
    y: 90.9,
    width: 35.8,
    height: 57.55,
    rx: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.7,
    y: 54.8,
    width: 35.8,
    height: 25.26,
    rx: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.9,57.5a2.7,2.7,0,0,0-2.6-2.7H271.8a2.7,2.7,0,0,0-2.7,2.7v87.1c0,2.1,1.2,3.8,2.7,3.8h30.5c1.4,0,2.6-1.7,2.6-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.9,79.1a2.9,2.9,0,0,1,2.9-2.7h77.8a2.7,2.7,0,0,0,2.7-2.6V57.6a2.9,2.9,0,0,0-2.8-2.9h-89a18.8,18.8,0,0,0-18.8,18.8v26.7a15.9,15.9,0,0,0,16,15.9h65.9a3.3,3.3,0,0,1,3.3,3.3v4.7a2.7,2.7,0,0,1-2.6,2.7H318.4a2.7,2.7,0,0,0-2.7,2.7v16.6a2.3,2.3,0,0,0,2.3,2.3h92.9A15.4,15.4,0,0,0,426.3,133V102.5a15.4,15.4,0,0,0-15.4-15.4H345.6a2.9,2.9,0,0,1-2.8-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.8,125.4h0a36.3,36.3,0,0,0-13.6-69.9l-87.3-.7a2.7,2.7,0,0,0-2.6,2.7v88.3a2.6,2.6,0,0,0,2.6,2.6h30.6a2.6,2.6,0,0,0,2.6-2.6V127.7h15.7L206,146.6a7,7,0,0,0,4.8,1.8h44.7a2.6,2.6,0,0,0,1.7-4.7ZM222,90.9H170.3a2.1,2.1,0,0,1-2.2-2.1V82.3a2.2,2.2,0,0,1,2.2-2.2h51.6a2.8,2.8,0,0,1,2.8,2.8V88A2.8,2.8,0,0,1,222,90.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.6,171.6A68,68,0,0,1,101,35.7a67,67,0,0,1,35.4,8.4h47.1a2.5,2.5,0,0,0,1.9-4A103.5,103.5,0,0,0,99.7.1C45.4,2.1,1.6,46.3,0,100.6a103.6,103.6,0,0,0,188,63,2.8,2.8,0,0,0-2.3-4.4h-43A67.4,67.4,0,0,1,103.6,171.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrisLogo);
export default __webpack_public_path__ + "static/media/iris_logo.75880bfe1b39e2212ce3ca5f85af7c7c.svg";
export { ForwardRef as ReactComponent };